import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DateService {
    //#region properties
    //#region private
    private _defaultLocal: any;
    private _digits = [
        {
            number: 0,
            digitEn: '0',
            digitAr: '٠'
        },
        {
            number: 1,
            digitEn: '1',
            digitAr: '١'
        },
        {
            number: 2,
            digitEn: '2',
            digitAr: '٢'
        },
        {
            number: 3,
            digitEn: '3',
            digitAr: '٣'
        },
        {
            number: 4,
            digitEn: '4',
            digitAr: '٤'
        },
        {
            number: 5,
            digitEn: '5',
            digitAr: '٥'
        },
        {
            number: 6,
            digitEn: '6',
            digitAr: '٦'
        },
        {
            number: 7,
            digitEn: '7',
            digitAr: '٧'
        },
        {
            number: 8,
            digitEn: '8',
            digitAr: '٨'
        },
        {
            number: 9,
            digitEn: '9',
            digitAr: '٩'
        }
    ]
    private _months = [
        {
            index: 1,
            nameEn: "January",
            nameAr: "يناير"
        },
        {
            index: 2,
            nameEn: "February",
            nameAr: "فبراير"
        },
        {
            index: 3,
            nameEn: "March",
            nameAr: "مارس"
        },
        {
            index: 4,
            nameEn: "April",
            nameAr: "أبريل"
        },
        {
            index: 5,
            nameEn: "May",
            nameAr: "مايو"
        },
        {
            index: 6,
            nameEn: "June",
            nameAr: "يونيو"
        },
        {
            index: 7,
            nameEn: "July",
            nameAr: "يوليو"
        },
        {
            index: 8,
            nameEn: "August",
            nameAr: "أغسطس"
        },
        {
            index: 9,
            nameEn: "September",
            nameAr: "سبتمبر"
        },
        {
            index: 10,
            nameEn: "October",
            nameAr: "أكتوبر"
        },
        {
            index: 11,
            nameEn: "November",
            nameAr: "نوفمبر"
        },
        {
            index: 12,
            nameEn: "December",
            nameAr: "ديسمبر"
        }
    ]
    private _hijriMonths = [
        {
            index: 1,
            nameEn: "Moharram",
            nameAr: "محرم"
        },
        {
            index: 2,
            nameEn: "Safar",
            nameAr: "صفر"
        },
        {
            index: 3,
            nameEn: "Rabih Al Awal",
            nameAr: "ربيع الأول"
        },
        {
            index: 4,
            nameEn: "Rabih Al Thani",
            nameAr: "ربيع الثاني"
        },
        {
            index: 5,
            nameEn: "Jumada Al Awal",
            nameAr: "جمادى الأول"
        },
        {
            index: 6,
            nameEn: "Jumada Al Thani",
            nameAr: "جمادى الثاني"
        },
        {
            index: 7,
            nameEn: "Ragab",
            nameAr: "رجب"
        },
        {
            index: 8,
            nameEn: "Shaaban",
            nameAr: "شعبان"
        },
        {
            index: 9,
            nameEn: "Ramadan",
            nameAr: "رمضان"
        },
        {
            index: 10,
            nameEn: "Shawal",
            nameAr: "شوال"
        },
        {
            index: 11,
            nameEn: "Dhu al Quada",
            nameAr: "ذو القعدة"
        },
        {
            index: 12,
            nameEn: "Dhu al Hujja",
            nameAr: "ذو الحجة"
        }
    ]
    private _days = [
        {
            index: 1,
            nameEn: "Monday",
            nameAr: "الإثنين"
        },
        {
            index: 2,
            nameEn: "Tuesday",
            nameAr: "الثلاثاء"
        },
        {
            index: 3,
            nameEn: "Wednesday",
            nameAr: "الأربعاء"
        },
        {
            index: 4,
            nameEn: "Thursday",
            nameAr: "الخميس"
        },
        {
            index: 5,
            nameEn: "Friday",
            nameAr: "الجمعة"
        },
        {
            index: 6,
            nameEn: "Saturday",
            nameAr: "السبت"
        },
        {
            index: 0,
            nameEn: "Sunday",
            nameAr: "الأحد"
        },
    ]
    //#endregion

    //#region public
    private _locales = {
        ar: 'ar',
        en: 'en'
    }
    //#endregion
    //#endregion

    //#region ctor
    constructor() {
        this._defaultLocal = this._locales.ar;
    }
    //#endregion

    //#region setters
    public set defaultLocal(value: any) {
        this._defaultLocal = value;
    }
    //#endregion

    //#region getters
    public get defaultLocal(): any {
        return this._defaultLocal;
    }
    //#endregion

    //#region private actions
    
    private getMonth(month: number) {
        let dMonth = this._months.find(m => m.index == month+1);
        if(this._defaultLocal == 'en')return dMonth?.nameEn;
        return dMonth?.nameAr;
    }
    public getHijriMonth(month: number) {
        let dMonth = this._hijriMonths.find(m => m.index == month+1);
        if(this._defaultLocal == 'en')return dMonth?.nameEn;
        return dMonth?.nameAr;
    }
    public getDay(ind: number) {
        let day =  this._days.find(d => d.index == ind);
        if(this._defaultLocal == 'ar')return day?.nameAr;
        return day?.nameEn;
    }
    //#endregionm

    //#region public actions
    public getDate() {
        let date = new Date();
        let year = this.getYear(date.getFullYear());
        let month = this.getMonth(date.getMonth());
        let day = this.getYear(date.getDate());
        let dayName = this.getDay(date.getDay());
        let result: string = "";
        if(this._defaultLocal == "en") {
            result =  day+", "+ month+ " " + year;
        } else {
            result =  day+"، "+ month+ " " + year;//year+" "+ month+ ", "+ day+" "+ dayName
        }
        return result;
    }
    public getYear(year: number) {
        let result: string = "";
        let strYear = year.toString();
        for(let i=0;i<strYear.length; i++) {
            let digit = this._digits.find(dg => dg.number == +strYear[i]);
            if(this._defaultLocal == 'en') {
                result+=digit?.digitEn;
            } else {
                result+=digit?.digitAr;
            }
        }
        return result;
    }
    //#endregion
    
    
}